import { useMutation, useQuery } from '@apollo/client'
import { Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { DEMANDE_UPDATE } from '../../../apollo/mutation/demande.mutation'
import { SINISTRE_BY_ID } from '../../../apollo/query/demande.query'
import { D4_Demande, D4_Demande_Set_Input, D4_Fn_View_Demande, D4_Lot } from '../../../types'
import SelectCoproprietaires from '../../SelectCoproprietaires'

const SelectOrigineSinistre = ({ demande }: { demande: D4_Fn_View_Demande }) => {
  const [updateDemande] = useMutation<{}, { id: number; data: D4_Demande_Set_Input }>(DEMANDE_UPDATE)
  const [origine, setOrigine] = useState(-1)
  const { data, loading } = useQuery<{ demande: D4_Demande }, { id: number }>(SINISTRE_BY_ID, {
    variables: { id: demande.id },
  })

  const handleSelect = async (value: number) => {
    setOrigine(value)
    await updateDemande({
      variables: {
        id: demande.id,
        data: { typeoriginesinistre: value },
      },
    })
  }

  const copaOrigine = async (id: number, lot: D4_Lot) => {
    await updateDemande({
      variables: {
        id: demande.id,
        data: { coproprietaireorigine_id: lot.lot_coproprietaire?.coproprietaire.id },
      },
    })
  }

  useEffect(() => {
    if (data?.demande?.typeoriginesinistre) {
      setOrigine(data.demande.typeoriginesinistre)
    }
  }, [data])

  if (loading) {
    return null
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <Select
        listHeight={800}
        style={{ minWidth: '240px' }}
        placeholder="Origine"
        onSelect={handleSelect}
        defaultValue={data?.demande?.typeoriginesinistre}
      >
        <Select.Option value={1}>Copropriété</Select.Option>
        <Select.Option value={2}>Copropriétaire</Select.Option>
        <Select.Option value={3}>Locataire</Select.Option>
        <Select.Option value={4}>Autre</Select.Option>
        <Select.Option value={0}>Inconnu</Select.Option>
      </Select>
      {origine === 2 && (
        <SelectCoproprietaires
          defaultValue={data?.demande.coproprietaireorigine_id}
          placeholder="Copropriétaire"
          style={{ minWidth: '240px' }}
          trigramme={demande.copropriete?.trigramme ?? ''}
          onChange={copaOrigine}
        />
      )}
    </div>
  )
}

export default SelectOrigineSinistre
